import 'react-phone-number-input/style.css'
import PhoneInput, { Country } from 'react-phone-number-input'
import en from 'react-phone-number-input/locale/en.json'

type Props = {
  value: string | undefined;
  onChange: (value: string | undefined) => void;
  name?: string;
  id?: string;
  label?: string;
  placeholder?: string;
  defaultCountry?: Country;
};

const PhoneNumberInput = ({ value, onChange, name, id, label, placeholder, defaultCountry }: Props) => {
  return (
    <div className="phone-input-wrap" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <div className="phone-input-label">
        <span>{label || 'Phone number'}</span>
      </div>
        <PhoneInput
          placeholder={placeholder || "Enter phone number"}
          value={value}
          onChange={onChange}
          defaultCountry={defaultCountry || 'US'}
          international
          countryCallingCodeEditable={false}
          withCountryCallingCode
          labels={en}
          className="phone-input"
        />

    </div>
  );
};

export default PhoneNumberInput;
